import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUserFromCallback } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login', { replace: true });
      return;
    }
    const sessionId = match[1];

    (async () => {
      try {
        const res = await fetch(`${API_URL}/api/auth/google-session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });
        if (!res.ok) throw new Error('Auth exchange failed');
        const data = await res.json();
        setUserFromCallback(data.user);
        navigate('/app', { replace: true, state: { user: data.user } });
      } catch {
        navigate('/login', { replace: true, state: { error: 'Google sign-in failed. Please try again.' } });
      }
    })();
  }, [navigate, setUserFromCallback]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#000',
      color: '#fff',
      flexDirection: 'column',
      gap: 16,
    }} data-testid="auth-callback">
      <Loader2 size={32} className="spinner" />
      <p style={{ fontSize: 14, opacity: 0.7 }}>Signing you in…</p>
    </div>
  );
};

export default AuthCallback;
